export default "__VITE_ASSET__Y$lmcq7T__"